import React, { Fragment, useCallback, useEffect, useState } from "react";
import { clone, isEmpty, pluck } from "ramda";

import CollectionTable from "./CollectionTable";
import MediaBrowser from "../../common/MediaBrowser";
import SearchBar from "../../common/SearchBar";
import TotalsHeader from "../../common/TotalsHeader";
import AddMediaToParentDropDown from "../../common/AddMediaToParentDropdown";
import AddNewCollectionDialog from "./AddNewCollectionDialog";
import SnackAlert from "../../../components/SnackAlert";
import { useSnackAlert } from "../../../common/use-snackAlert";
import { useSearchQuery } from "../../common/use-searchQuery";
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

const CollectionBrowser = props => {
  const {
    searchState,
    onSearchStateChange,
    searchResults,
    onSaveSuccess,
  } = props;
  const [scrollVisible, setScrollVisible] = useState(true);
  const [collectionsSelected, setCollectionsSelected] = useState([]);

  const navigate = useNavigate();

  //-- Handle Search state
  const initialState = clone(searchState);
  const {
    state,
    handleUpdateSort,
    handleUpdateQuery,
    handleUpdatePage,
  } = useSearchQuery(initialState);

  //-- Whenever the internal search state changes, update the search state stored in the parent
  useEffect(() => {
    onSearchStateChange(state);
    setScrollVisible(true);
  }, [onSearchStateChange, state]);

  //-- Manage the alert message
  // const { SnackAlert, showAlert } = useSnackAlert();
  const snackAlertHandler = useSnackAlert();
  const { showAlert } = snackAlertHandler;

  const handleScrollVisible = useCallback(visible => {
    setScrollVisible(visible);
  }, []);

  const [disableDropdown, setDisableDropdown] = useState(true);

  const handleSelectChange = useCallback(selected => {
    setDisableDropdown(isEmpty(selected));
    setCollectionsSelected(selected);
  }, []);

  const [open, setOpen] = useState(false);
  const openNewCollectionDialog = () => setOpen(true);
  const onClose = () => setOpen(false);
  const closeNewCollectionDialog = ({ redirectPath, newCollectionId }) => {
    setOpen(false);
    navigate(`${redirectPath}/${newCollectionId}`);
  };

  return (
    <Fragment>
      <SnackAlert handler={snackAlertHandler} />
      <AddNewCollectionDialog
        open={open}
        onSave={closeNewCollectionDialog}
        onClose={onClose}
      />
      <MediaBrowser
        loaded={searchResults.isSuccess}
        scrollVisible={scrollVisible}
        searchBar={
          <SearchBar
            query={state.appliedQuery}
            onQueryChange={handleUpdateQuery}
          />
        }
        totalsHeader={
          <TotalsHeader
            count={
              searchResults.isSuccess ? searchResults.data.totalCount : "-"
            }
            countText="Collection"
            selectedActions={
              <div>
                <Button
                  variant="text"
                  startIcon={<AddIcon />}
                  onClick={openNewCollectionDialog}
                >
                  New Collection
                </Button>
                <AddMediaToParentDropDown
                  parent="anthology"
                  disableButton={disableDropdown}
                  childList={collectionsSelected}
                  showAlert={showAlert}
                  handleAddSuccess={onSaveSuccess}
                />
                <AddMediaToParentDropDown
                  parent="module"
                  disableButton={disableDropdown}
                  childList={pluck("id", collectionsSelected)}
                  showAlert={showAlert}
                  handleAddSuccess={onSaveSuccess}
                />
              </div>
            }
          />
        }
        mediaTable={
          <CollectionTable
            searchState={searchState}
            collectionList={
              searchResults.isSuccess ? searchResults.data.media : []
            }
            total={searchResults.isSuccess ? searchResults.data.totalCount : 0}
            page={state.page}
            orderBy={state.orderBy}
            order={state.orderDirection}
            onSortChange={handleUpdateSort}
            onPageChange={handleUpdatePage}
            onSelectChange={handleSelectChange}
            onScrollVisible={handleScrollVisible}
          />
        }
      />
    </Fragment>
  );
};

export default CollectionBrowser;
